import { DesignTokenColor } from '@src/theme';

export const ALL_ICONS = [
  // regular
  'award',
  'arrow-down-to-line',
  'arrow-up-from-bracket',
  'calendar-check',
  'calendar',
  'camera',
  'chart-line',
  'check',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'circle-check',
  'circle-dollar-to-slot',
  'clock',
  'credit-card',
  'edit',
  'ellipsis-vertical',
  'exclamation-triangle',
  'eye-regular',
  'file-plus',
  'gear',
  'heart',
  'info-circle',
  'landmark',
  'list-check',
  'location-crosshairs',
  'location-dot',
  'mobile',
  'plane',
  'paper-plane',
  'person-outline',
  'phone',
  'plus',
  'search',
  'sparkles',
  'trash',
  'user-search',
  'xmark',
  // light
  'light-burger-soda',
  'light-calendar-check',
  'light-calendar-clock',
  'light-calendar-day',
  'light-clipboard-check',
  'light-info-circle',
  'light-lightbulb-exclamation-on',
  'light-parking-circle',
  'light-shield-check',
  'light-tshirt',
  'light-location-dot',
  'light-calendar',
  'light-clock',
  'light-star-of-life',
  'ligh-scalpel',
  'light-head-side-medical',
  'light-syringe',
  'light-hospital',
  'light-ban',
  'light-id-badge',
  'light-door-open',
  'light-window',
  'light-house',
  'light-phone',
  'light-briefcase-medical',
  // solid
  'solid-circle-exclamation',
  'solid-heart',
  'solid-info-circle',
  'solid-mountains',
  'caret-down-solid',
  'caret-up-solid',
] as const;

export type IconName = (typeof ALL_ICONS)[number];

export type IconColor =
  | 'info'
  | 'success'
  | 'warning'
  | 'error'
  | 'primary'
  | 'secondary'
  | 'tertiary';

export type IconVariant = 'light' | 'dark' | 'custom';

export type IconProps = IconColors & {
  name: IconName;
  iconSize?: `${number}px`;
  boxSize?: `${number}px`;
};

type IconColors = LightColor | DarkColor | CustomColor;

export type LightColor = {
  variant?: 'light';
  color?: IconColor;
  backgroundColor?: never;
};

export type DarkColor = {
  variant?: 'dark';
  color?: IconColor;
  backgroundColor?: never;
};

export type CustomColor = {
  variant?: 'custom';
  color?: DesignTokenColor | string;
  bgColor?: DesignTokenColor | string;
};
